import(/* webpackMode: "eager" */ "/var/www/turivana/frontend/src/app/[locale]/contacto/page.tsx");
